import React, { useEffect, useRef, useState } from 'react';

import NavBar from './components/NavBar';
import Home from './sections/Home';
import AboutUs from './sections/AboutUs';
import Contact from './sections/Contact';

import Theme from './ui/Theme';

import { ThemeProvider } from '@material-ui/core';
import { scroller } from 'react-scroll';

import Menu from './components/Menu';
import MiddlewareCarrousel from './sections/MiddlewareCarrousel';
import LisCarrousel from './sections/LisCarrousel';

const useOnScreen = (options) => {

  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    };
  }, [ref, options]);

  return [ref, visible];
};

function App() {

  const [ref, visible] = useOnScreen({ threshold: 0.1 });
  const [lisRef, lisVisible] = useOnScreen({ threshold: 0.1 });
  const [midRef, midVisible] = useOnScreen({ threshold: 0.1 });
  const [openMenu, setOpenMenu] = useState(false);

  const handleClickMenu = (to) => {
    setOpenMenu(false);

    scroller.scrollTo(to, {
      duration: 100,
      delay: 0,
      smooth: false
    });
  }

  return (
    <ThemeProvider theme={Theme}>
      <div style={{ overflow: "hidden" }}>
        <div id="navbar"><NavBar onClickMenu={(to) => handleClickMenu(to)} openMenu={() => setOpenMenu(!openMenu)} alterBackground={!visible} menuIsOpen={openMenu}></NavBar></div>
        <div id="menu"><Menu onClickMenu={(to) => handleClickMenu(to)} open={openMenu}></Menu></div>
        <section id="home" ref={ref}><Home /></section>
        <section id="lis" ref={lisRef} style={{ zIndex: 1000 }}><LisCarrousel visible={lisVisible} /></section>
        <section id="middleware" ref={midRef} style={{ zIndex: 1000 }}><MiddlewareCarrousel visible={midVisible} /></section>
        <section id="about" style={{ zIndex: 1000 }}><AboutUs /></section>
        <section id="contact" style={{ zIndex: 1000 }}><Contact /></section>
      </div>
    </ThemeProvider>

  );
}

export default App;
